import { getLocale } from "../runtime";

const sv_svlanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Svenska`
};

const svlanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_svlanguage(inputs)
	return "svLanguage";
};

export { svlanguage as "svLanguage" };